import React, { useState } from "react";
import { Button, Stack } from "@mui/material";
import "../../../Myaccount/Myaccount.css";

import { useTranslation } from "react-i18next";
import "../../../../Localization/i18n";

import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableBody from '@mui/material/TableBody';

import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Edit from "../../../../icons/edit.svg";
import CompanyAccessDialog from "../CompanyAccessDialog";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.action.hover,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

export default function CompanyAccess({
  userId,
  orgId,
  orgName,
  userRole,
  onRoleSave,
  SuperUser,
  PrincipalCompanyOfficerName,
  MOD
}) {
  const { t } = useTranslation();

  const [isSaving, setIsSaving] = useState(false);
  const [editDialogOpen, setEditDialogOpen] = useState(false);



  const handleDialogClose = () => {
    setEditDialogOpen(false);
    onRoleSave();
  };
  //const SuperUserIds = ["F074E6AF-742D-4160-A526-428B7BFF95B0", "A70DCA84-DECC-4909-8AB6-46F6E10B8BA2", "CA273015-15EC-4AC1-BB9D-4D7E4B846521", "E873989B-3051-438B-A421-057051C3123B"]
  return (
    <>
      {editDialogOpen && (
        <CompanyAccessDialog
          setEditDialogOpen={setEditDialogOpen}
          handleDialogClose={handleDialogClose}
          userId={userId}
          orgId={orgId}
        />
      )}

      <div className="form">
        <Stack direction={"row"} spacing={10}>
          <h4 className="personal-info-heading" variant="contained">
            Company Access
          </h4>
          {userRole == "" ? <span style={{ color: "red" }}>(must select security role below before saving.)</span> : ""}
        </Stack>
        <Table aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Name of the Company</StyledTableCell>
              <StyledTableCell>Assigned Roles</StyledTableCell>
              <StyledTableCell>&nbsp;</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <StyledTableCell sx={{ width: "50%" }}>
                <span style={{ fontSize: "15px" }}>{orgName}</span><br />
                <span style={{ fontSize: "15px" }}>{PrincipalCompanyOfficerName}</span>
              </StyledTableCell>
              <StyledTableCell sx={{ width: "40%" }}>
                {userRole}
              </StyledTableCell>
              <StyledTableCell sx={{ width: "40%" }}>
                {MOD &&
                  <Button
                    hidden={SuperUser}
                    variant="outlined"
                    color="primary"
                    onClick={() => setEditDialogOpen(true)}
                  >
                    <img src={Edit} alt="editicon" />{" "}
                  </Button>}
              </StyledTableCell>
            </TableRow>
          </TableBody>
        </Table>

        <div className="row mt-3 mb-3 d-none">
          <div className="text-right" style={{ marginLeft: "-23px" }}>
            <Button
              variant="outlined"
              color="primary"
              style={{
                marginRight: "10px",
                textTransform: "capitalize",
                padding: "15px",
              }}
            >
              {t("Myinformation.cancle")}
            </Button>

            <Button
              variant="contained"
              color="primary"
              style={{ textTransform: "capitalize", padding: "15px" }}
            >
              {t("Myinformation.save")}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
